import React from "react";
import "./Clinics/clinics.css";

// Dummy clinics data
const clinics = [
  {
    id: 1,
    name: "Clinic One",
    credit_detail: [
      {
        id: 894,
        channel_type: "sms",
        total_credit: 1,
        consumed_credit: 0,
        remaing_credits: 1,
        used_messages: 0,
        total_messages: 5,
        over_used_messages: 0
      },
      {
        id: 895,
        channel_type: "whatsapp",
        total_credit: 1,
        consumed_credit: 0,
        remaing_credits: 1,
        used_messages: 0,
        total_messages: 3,
        over_used_messages: 0
      },
      {
        id: 896,
        channel_type: "email",
        total_credit: 1,
        consumed_credit: 0,
        remaing_credits: 1,
        used_messages: 0,
        total_messages: 2,
        over_used_messages: 0
      }
    ]
  },
  {
    id: 2,
    name: "Clinic Two",
    credit_detail: [
      {
        id: 897,
        channel_type: "sms",
        total_credit: 2,
        consumed_credit: 1,
        remaing_credits: 1,
        used_messages: 1,
        total_messages: 6,
        over_used_messages: 0
      },
      {
        id: 898,
        channel_type: "whatsapp",
        total_credit: 2,
        consumed_credit: 0,
        remaing_credits: 2,
        used_messages: 0,
        total_messages: 4,
        over_used_messages: 0
      },
      {
        id: 899,
        channel_type: "email",
        total_credit: 2,
        consumed_credit: 0,
        remaing_credits: 2,
        used_messages: 0,
        total_messages: 3,
        over_used_messages: 0
      }
    ]
  }
];

const channelIcon = {
  sms: "💬",
  whatsapp: "📱",
  email: "✉️"
};

const channelColor = {
  sms: { bg: "#e8f4fd", accent: "#2196f3", badge: "#bbdefb" },
  whatsapp: { bg: "#e8f5e9", accent: "#4caf50", badge: "#c8e6c9" },
  email: { bg: "#fff3e0", accent: "#ff9800", badge: "#ffe0b2" }
};

function StatRow({ label, value, valueStyle }) {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        padding: "6px 0",
        borderBottom: "1px solid #f0f0f0"
      }}
    >
      <span style={{ color: "#6b7280", fontSize: "0.82rem" }}>{label}</span>
      <span style={{ fontWeight: 600, fontSize: "0.88rem", ...valueStyle }}>{value}</span>
    </div>
  );
}

function CreditCard({ channel }) {
  const colors = channelColor[channel.channel_type] || {
    bg: "#f8f9fa",
    accent: "#6c757d",
    badge: "#e9ecef"
  };

  return (
    <div
      style={{
        backgroundColor: "#ffffff",
        border: "1px solid #e5e7eb",
        borderRadius: 12,
        overflow: "hidden",
        boxShadow: "0 2px 8px rgba(0,0,0,0.06)",
        display: "flex",
        flexDirection: "column",
        transition: "box-shadow 0.2s ease"
      }}
      onMouseEnter={e => (e.currentTarget.style.boxShadow = "0 4px 16px rgba(0,0,0,0.12)")}
      onMouseLeave={e => (e.currentTarget.style.boxShadow = "0 2px 8px rgba(0,0,0,0.06)")}
    >
      {/* Card header */}
      <div
        style={{
          backgroundColor: colors.bg,
          padding: "14px 18px",
          display: "flex",
          alignItems: "center",
          gap: 10,
          borderBottom: "1px solid #e5e7eb"
        }}
      >
        <span style={{ fontSize: "1.3rem", lineHeight: 1 }}>{channelIcon[channel.channel_type] || "📦"}</span>
        <span
          style={{
            fontWeight: 700,
            fontSize: "0.95rem",
            textTransform: "capitalize",
            color: colors.accent
          }}
        >
          {channel.channel_type}
        </span>
      </div>

      {/* Total credit highlight */}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "12px 18px",
          backgroundColor: colors.badge,
          borderBottom: "1px solid #e5e7eb"
        }}
      >
        <span style={{ fontSize: "0.82rem", color: "#374151", fontWeight: 600 }}>Total Credits</span>
        <span
          style={{
            fontSize: "1.25rem",
            fontWeight: 800,
            color: colors.accent
          }}
        >
          {channel.total_credit}
        </span>
      </div>

      {/* Stats */}
      <div style={{ padding: "12px 18px", display: "flex", flexDirection: "column", gap: 0 }}>
        <StatRow label="Consumed Credits" value={channel.consumed_credit} />
        <StatRow
          label="Remaining Credits"
          value={channel.remaing_credits}
          valueStyle={{ color: "#16a34a" }}
        />
        <StatRow
          label="Used / Total Messages"
          value={`${channel.used_messages} / ${channel.total_messages}`}
        />
        <StatRow
          label="Over-used Messages"
          value={channel.over_used_messages}
          valueStyle={channel.over_used_messages > 0 ? { color: "#f97316" } : {}}
        />
      </div>
    </div>
  );
}

function AllCredits() {
  return (
    <div style={{ minHeight: "71vh", padding: "24px 32px" }}>
      <h3 className="title-of-page" style={{ marginBottom: 28 }}>
        All Clinics Credits
      </h3>

      <div style={{ display: "flex", flexDirection: "column", gap: 32 }}>
        {clinics.map(clinic => (
          <div
            key={clinic.id}
            style={{
              backgroundColor: "#f8fafc",
              border: "1px solid #e2e8f0",
              borderRadius: 14,
              padding: "20px 24px",
              boxShadow: "0 1px 4px rgba(0,0,0,0.05)"
            }}
          >
            <h5
              style={{
                fontWeight: 700,
                fontSize: "1rem",
                color: "#1e293b",
                marginBottom: 18,
                paddingBottom: 12,
                borderBottom: "2px solid #e2e8f0"
              }}
            >
              🏥 {clinic.name}
            </h5>

            <div
              style={{
                display: "grid",
                gridTemplateColumns: "repeat(auto-fill, minmax(32%, 1fr))",
                gap: 16
              }}
            >
              {clinic.credit_detail.map(channel => (
                <CreditCard key={channel.id} channel={channel} />
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default AllCredits;
